import BaseInput from '@/mixins/BaseInput';

export default {
  mixins: [BaseInput],
  props: {
    size: String,
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: this.value,
      internalErrors: this.errors || [],
    };
  },
  watch: {
    value(value) {
      this.internalValue = value;
    },
    errors(errors) {
      this.internalErrors = errors;
    },
  },
  computed: {
    isInvalid() {
      return this.internalErrors && this.internalErrors.length > 0;
    },
    isValid() {
      return !this.isInvalid;
    },
    inputCss() {
      return {
        'uk-form-danger': this.isInvalid,
        [`uk-form-${this.size}`]: !!this.size,
      };
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.internalValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
      this.clearErrors();
    },
    clearErrors() {
      this.internalErrors = [];
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/Input.js